import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import type {Context} from '../types';

// Convert invalid symbol instances tag name to div
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}, tag, type} = jsonNode;
  const isSymbolInstance = DomTypeUtils.isSymbolInst(data);
  // `isNotLineBreak` was added after this Hot Patch was shipped, in order to
  // help us determine if there are other User Component instances that are not
  // don't have tag `div` than `LineBreak` Plugin Components.
  const isNotLineBreak = type !== 'LineBreak';

  return {
    needed: isSymbolInstance && isNotLineBreak && tag !== 'div',
    logData: {
      msg: 'SymbolInstance without div tagname',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      jsonNode.tag = 'div';
    },
  };
};
